<script setup lang="ts">
const props = withDefaults(defineProps<{
  modelValue: boolean
  title: string
  confirmLabel?: string
}>(), {
  confirmLabel: "J'ai compris",
})

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  confirm: []
}>()

function closeModal(): void {
  emit('update:modelValue', false)
}

function confirmModal(): void {
  emit('confirm')
  closeModal()
}
</script>

<template>
  <div
    v-if="props.modelValue"
    class="notice-modal-overlay"
    role="dialog"
    aria-modal="true"
    :aria-label="props.title"
  >
    <div class="notice-modal">
      <h2>{{ props.title }}</h2>
      <div class="notice-modal-content">
        <slot />
      </div>
      <div class="notice-modal-actions">
        <button type="button" class="notice-modal-confirm" @click="confirmModal">
          {{ props.confirmLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "~/assets/scss/partials/elpdl/spacing" as *;

.notice-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: $spacing-3xl $spacing-l;
  background: var(--color-overlay-scrim);
}

.notice-modal {
  width: min(760px, 100%);
  max-height: calc(100vh - 2 * #{$spacing-3xl});
  overflow: auto;
  background: var(--color-bg-elevated);
  border-radius: 14px;
  border: 1px solid var(--color-border);
  box-shadow: var(--color-shadow-modal);
  padding: $spacing-xl;
  margin-block: $spacing-m;

  h2 {
    margin-top: 0;
    margin-bottom: $spacing-m;
    color: var(--color-primary-active);
    font-size: 32px;
    line-height: 1.1;
  }
}

.notice-modal-content {
  color: var(--color-text-secondary);
  line-height: 1.55;
  font-size: 18px;
  padding-block: $spacing-s;

  p {
    margin: 0 0 $spacing-m;
  }
}

.notice-modal-actions {
  margin-top: $spacing-m;
  display: flex;
  justify-content: flex-end;
}

.notice-modal-confirm {
  appearance: none;
  border: 1px solid var(--color-primary);
  border-radius: 8px;
  background: var(--color-primary);
  color: var(--color-text-on-primary);
  padding: $spacing-2xs $spacing-l;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: var(--color-primary-hover);
    border-color: var(--color-primary-hover);
  }
}
</style>
